module.exports = __webpack_public_path__ + "img/image5.d4536997.webp";